module.exports = __webpack_public_path__ + "img/headline_bottom@3x.255857bd.png";